export default __webpack_public_path__ + "static/media/cart.408dbc93.png";